/** The crop season ids selected in the global season picker. */
const getSeasons = (): string[] | null =>
  JSON.parse(localStorage.getItem('selectedCropSeasons') as string);

export default getSeasons;
